export default __webpack_public_path__ + "static/SR China - HACCP - Certificate-6c16be971f105bc519fadbfcd67aaaab.pdf";